module.exports = __webpack_public_path__ + "img/v20.8866ecd8.jpg";